<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.areas') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-graduation-cap"></i>
          <span>{{ $ml.get('shared.studentTransactions') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.areas') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-6">
          <div class="input-group">
            <span class="input-group-addon text-lg">Seçilen Bölge :</span>
            <select @change="viewSelectArea($event)" class="form-control text-bold input-lg">
              <option value>Seçilmedi</option>
              <option v-for="ar in areaList" :key="ar.id" :selected="ar.id == viewSelectedArea.id" :value="ar.id">
                {{ ar.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-3 text-center">
          <button class="btn btn-lg btn-primary" style="width:100%;" data-target="#modal-area" data-toggle="modal">
            <i class="fa fa-building"></i> Bölge Tanımları
          </button>
        </div>
        <div class="col-sm-3 text-center">
          <button class="btn btn-lg btn-info" style="width:100%;" data-target="#modal-room-types" data-toggle="modal">
            <i class="fa fa-map-signs"></i> Daire Tipleri
          </button>
        </div>
      </div>
      <div class="row">
        <div v-show="selectedViewFloorList.length == 0 && !isLoading" class="col-sm-12" style="margin-top:10px;">
          <div class="callout callout-warning">
            <i class="fa fa-info-circle"></i>
            <span
              v-text="viewSelectedArea.id ? 'Kayıtlı kat bulunamadı. Bölge tanımlarından kat kaydedebilirsiniz...' : 'Lütfen önce bölge seçin...'"></span>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="box-header" style="margin-top:20px;">
            <h3 class="box-title" style="font-size:24px;line-height:1.1;">1. Kat</h3>
            <div class="box-title pull-right">
            </div>
          </div>
          <hr style="border-top: 1px solid #000; margin-top:10px;" />
          <div class=""
            style="background: url('/src/assets/zemin.png');width: 100%;height: 100vh;background-repeat: no-repeat;background-size: contain;">
            <i @click="openDevice()" class="fa fa-camera" style="color:orange;cursor: pointer;position: relative;top:200px;left:200px;font-size:25px;"></i>
          </div>
        </div>
      </div>
      <div class="overlay"
        :style="'font-size:30px;text-align:center;background-color:#fff;margin-top:10px;' + windowHeightSize" id="load"
        :hidden="!isLoading">
        <i style="margin:150px;" class="fa fa-refresh fa-spin"></i>
      </div>
      <!--AREA MODAL -->
      <div class="modal modal-primary fade" id="modal-area" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Bölge Tanımları</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">Bölge Listesi</h4>
                      <div class="pull-right box-tools">
                        <button @click="newArea()" class="btn btn-sm btn-warning">Yeni Bölge</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="areaList.length > 0" class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="area in areaList" :key="area.id">
                              <td>{{ area.name }}</td>
                              <td>
                                <button @click="selectArea(area.id, area.name)" class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="areaList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        Bölge kaydı bulunamadı.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>Bölge Adı</label>
                    <input v-model="selectedArea.name" type="text" class="form-control" />
                  </div>
                  <label>Katlar</label>
                  <div v-show="!isNewArea" class="callout callout-info">
                    <div class="row">
                      <div class="col-sm-8">
                        <div class="form-group">
                          <label>Kat Adı</label>
                          <input type="text" class="form-control" v-model="selectedFloor.name" />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Sıra Numarası</label>
                          <input type="number" min="1" class="form-control" v-model="selectedFloor.orderNo" />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <button v-show="!isNewFloor" class="btn btn-outline" @click="newFloor()">
                          <i class="fa fa-times"></i> İptal
                        </button>
                      </div>
                      <div class="col-sm-4">
                        <button v-show="!isNewFloor" class="btn btn-danger" @click="deleteField(selectedFloor.id, 1)">
                          <i class="fa fa-trash"></i> Sil
                        </button>
                      </div>
                      <div class="col-sm-4">
                        <button class="btn btn-success" @click="saveFloor()">
                          <span v-show="isNewFloor">
                            <i class="fa fa-plus"></i> Yeni Kat Ekle
                          </span>
                          <span v-show="!isNewFloor">
                            <i class="fa fa-refresh"></i> Güncelle
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-sm-12">
                      <ul>
                        <li v-for="floor in selectedFloorList" :key="floor.id" style="margin-bottom:5px;">
                          {{ floor.name }}
                          <button class="btn btn-xs btn-primary" style="margin-left:5px;"
                            @click="selectFloor(floor.id, floor.name)">
                            <i class="fa fa-search"></i>
                          </button>
                        </li>
                      </ul>
                      <div v-show="selectedFloorList.length == 0" class="callout callout-warning">
                        <i class="fa fa-info-circle"></i>
                        <span v-text="!isNewArea ? 'Kat bulunamadı.' : 'Lütfen önce bölgeyi kaydedin.'"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="!isNewArea" type="button" @click="deleteField(selectedArea.id, 0)" class="btn btn-danger">
                <span>
                  <i class="fa fa-trash"></i>
                  {{ $ml.get('general.delete') }}
                </span>
              </button>
              <button type="button" @click="saveArea()" class="btn btn-success">
                <span v-show="isNewArea">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('general.save') }}
                </span>
                <span v-show="!isNewArea">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('general.update') }}
                </span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--AREA MODAL END -->
      <!--ROOM TYPE MODAL -->
      <div class="modal modal-info fade" id="modal-room-types" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Daire Tipleri</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">Daire Tipi Listesi</h4>
                      <div class="pull-right box-tools">
                        <button @click="newRoomType()" class="btn btn-sm btn-warning">Yeni Daire Tipi</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="roomTypeList.length > 0" class="table-responsive no-padding"
                        style="max-height:250px; overflow:auto; color:black;">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="roomType in roomTypeList" :key="roomType.id">
                              <td>{{ roomType.name }}</td>
                              <td>
                                <button @click="selectRoomType(roomType.id, roomType.name)"
                                  class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="roomTypeList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        Daire tipi kaydı bulunamadı.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>Daire Tipi Adı</label>
                    <input v-model="selectedRoomType.name" type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button v-show="!isNewRoomType" type="button" @click="deleteRoomType(selectedRoomType.id)"
                class="btn btn-danger">
                <span>
                  <i class="fa fa-trash"></i>
                  {{ $ml.get('general.delete') }}
                </span>
              </button>
              <button type="button" @click="saveRoomType()" class="btn btn-success">
                <span v-show="isNewRoomType">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('general.save') }}
                </span>
                <span v-show="!isNewRoomType">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('general.update') }}
                </span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ROOM TYPE MODAL END -->
      <!--ROOM DETAIL MODAL -->
      <div class="modal fade" id="modal-room-detail" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Oda Detayı</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <span :class="customColor2">
                    <img src="/src/assets/room-white-150.png" style="height:150px; margin-top:20px;" />
                  </span>
                  <hr />
                  <h4>
                    <span class="text-muted">
                      <i class="fa fa-home"></i> Oda Adı :
                    </span>
                    {{ viewSelectedRoom.name }}
                  </h4>
                  <h4>
                    <span class="text-muted">
                      <i class="fa fa-bed"></i> Kapasite :
                    </span>
                    {{ viewSelectedRoom.capacity }}
                  </h4>
                  <h4>
                    <span class="text-muted">
                      <i class="fa fa-users"></i> Mevcut Kişi :
                    </span>
                    {{ viewSelectedRoom.usesCount }}
                  </h4>
                  <h4>
                    <span class="text-muted">
                      <i class="fa fa-map-signs"></i> Daire Tipi :
                    </span>
                    {{ getRoomTypeName(viewSelectedRoom.roomTypeId) }}
                  </h4>
                  <h4>
                    <span class="text-muted">
                      <i class="fa fa-sort"></i> Sıra Numarası :
                    </span>
                    {{ viewSelectedRoom.orderNo }}
                  </h4>
                  <div class="form-group text-center">
                    <button class="btn btn-primary" style="width:100%;" @click="editRoom()">
                      <i class="fa fa-edit"></i> Odayı Düzenle
                    </button>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="box-header">
                    <h4 class="box-title" style="font-size:20px;line-height:1.1;">Mevcut Kişiler</h4>
                    <div class="box-title pull-right">
                      <button type="button" class="btn btn-warning" @click="newEmployees()">
                        <i class="fa fa-plus"></i> Kişi Ekle
                      </button>
                    </div>
                  </div>
                  <hr style="margin-top:10px;" />
                  <ul class="products-list product-list-in-box">
                    <li class="item" v-show="viewSelectedRoom.usesCount > 0 && !isLoadingUsesEmployees"
                      v-for="(emp, index) in viewSelectedRoom.usesEmployees" :key="emp.id">
                      <div class="row">
                        <div class="col-sm-3 text-center">
                          <img :src="emp.image ? emp.image : '/src/assets/default-user.png'" style="width:70px;" />
                        </div>
                        <div class="col-sm-6 text-center" style="margin-top:10px;">
                          <a class="product-title">{{ emp.registrationNumber }} - {{ emp.name }}</a>
                          <span class="product-description">{{ emp.title }}</span>
                        </div>
                        <div class="col-sm-3 text-center">
                          <button class="btn btn-danger" @click="removeEmployee(emp, index)" style="margin:10px;">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </li>
                    <!-- /.item -->
                  </ul>
                  <div class="callout callout-info" v-show="viewSelectedRoom.usesCount == 0">
                    <i class="fa fa-info-circle"></i> Kişi kaydı mevcut değil.
                  </div>
                  <div class="overlay"
                    :style="'font-size:30px;text-align:center;background-color:#fff;margin-top:10px;' + windowEmployeesHeightSize"
                    id="load" :hidden="!isLoadingUsesEmployees">
                    <i style="margin:150px;" class="fa fa-refresh fa-spin"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--ROOM DETAIL MODAL END-->
      <!--EMPLOYEES MODAL -->
      <div class="modal fade" id="employees-modal" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Eklenecek Kişileri Seçin ({{ viewSelectedRoom.capacity }} / {{ viewSelectedRoom.usesCount }} kişi
                  seçildi.)</span>
              </h4>
            </div>
            <div class="modal-body">
              <div @keyup.enter="getEmployees()" class="row">
                <div class="col-sm-12">
                  <div class="input-group" style="margin-bottom:7px;">
                    <input type="text" :placeholder="$ml.get('visitors.searchEmployeeFromList')"
                      v-model="filters.nameOrCardNumber" class="form-control" />
                    <span class="input-group-btn">
                      <button @click="getEmployees()" type="button" class="btn btn-primary">
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div v-show="allEmployeeFilteredList.length > 0 && !isLoadingEmployee"
                    class="table-responsive no-padding" :style="windowEmployeesHeightSize">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="employee1 in allEmployeeFilteredList" :key="employee1.id"
                          @click="employee1.isCheck = !employee1.isCheck">
                          <td>
                            {{ employee1.sicilNo }} - {{ employee1.name }}
                            <span v-show="employee1.title">- {{ employee1.title }}</span>
                          </td>
                          <td class="pull-right">
                            <button :disabled="employee1.isAtRoom"
                              v-show="viewSelectedRoom.usesCount < viewSelectedRoom.capacity || employee1.isCheck == true"
                              type="button"
                              :class="employee1.isCheck ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm'">
                              <i v-show="!employee1.isCheck" class="fa fa-times"></i>
                              <i v-show="employee1.isCheck" class="fa fa-check"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="overlay"
                    :style="'font-size:30px;text-align:center;background-color:#fff;margin-top:10px;' + windowEmployeesHeightSize"
                    id="load" :hidden="!isLoadingEmployee">
                    <i style="margin:150px;" class="fa fa-refresh fa-spin"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button type="button" @click="addEmployee()" class="btn btn-success">
                <span>
                  <i class="fa fa-plus"></i>
                  Seçilenleri Odaya Ekle
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--EMPLOYEES MODAL END-->
      <!--ROOM MODAL -->
      <div class="modal fade" id="room-modal" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span v-show="isNewRoom">Yeni Oda Oluştur</span>
                <span v-show="!isNewRoom">Oda Düzenle</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-4">
                  <span :class="isNewRoom ? 'detail-box bg-orange text-center' : 'detail-box bg-blue text-center'">
                    <img src="/src/assets/room-white-150.png" style="height:150px; margin-top:20px;" />
                  </span>
                </div>
                <div class="col-sm-8">
                  <div class="form-group">
                    <label>
                      <span class="text-muted">
                        <i class="fa fa-home"></i> Oda Adı
                      </span>
                    </label>
                    <input type="text" class="form-control" v-model="viewSelectedRoom.name" />
                  </div>
                  <div class="form-group">
                    <label>
                      <span class="text-muted">
                        <i class="fa fa-bed"></i> Kapasite
                      </span>
                    </label>
                    <input type="number" class="form-control" v-model="viewSelectedRoom.capacity" />
                  </div>
                  <div class="form-group">
                    <label>
                      <span class="text-muted">
                        <i class="fa fa-sort"></i> Sıra Numarası
                      </span>
                    </label>
                    <input type="number" class="form-control" v-model="viewSelectedRoom.orderNo" />
                  </div>
                  <div class="form-group">
                    <label>
                      <span class="text-muted">
                        <i class="fa fa-map-signs"></i> Daire Tipi
                      </span>
                    </label>
                    <select @change="changeRoomType($event)" class="form-control">
                      <option value>Seçilmedi</option>
                      <option v-for="roomType in roomTypeList" :key="roomType.id" :value="roomType.id"
                        :selected="viewSelectedRoom.roomTypeId == roomType.id">{{ roomType.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{ $ml.get('general.cancel')
              }}</button>
              <button data-dismiss="modal" v-show="!isNewRoom" type="button"
                @click="deleteField(viewSelectedRoom.id, 2)" class="btn btn-danger">
                <span>
                  <i class="fa fa-trash"></i>
                  {{ $ml.get('general.delete') }}
                </span>
              </button>
              <button type="button" @click="saveRoom()" class="btn btn-success" data-dismiss="modal">
                <span v-show="isNewRoom">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('general.save') }}
                </span>
                <span v-show="!isNewRoom">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('general.update') }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--ROOM MODAL END-->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: true,
      isLoadingDetail: true,
      isLoadingEmployee: false,
      isLoadingUsesEmployees: false,
      isNewArea: true,
      isNewFloor: true,
      isNewRoom: true,
      isNewRoomType: true,
      selectedArea: {
        id: null,
        name: "",
        floors: []
      },
      selectedFloor: {
        id: null,
        name: "",
        areaId: null,
        orderNo: 1,
        rooms: []
      },
      selectedRoom: {
        id: null,
        name: "",
        capacity: 0,
        usesEmployees: [],
        orderNo: 1,
        floorId: null,
        areaId: null,
        roomTypeId: null,
        usesCount: 0
      },
      selectedRoomType: {
        id: null,
        name: ""
      },
      viewSelectedArea: {
        id: null,
        name: "",
        floors: []
      },
      viewSelectedRoom: {
        id: null,
        name: "",
        capacity: 0,
        usesEmployees: [],
        orderNo: 1,
        floorId: null,
        areaId: null,
        roomTypeId: null,
        usesCount: 0
      },
      areas: [],
      floors: [],
      rooms: [],
      roomTypes: [],
      employees: [],
      selectedEmployees: [],
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      }
    };
  },
  computed: {
    areaList() {
      return this.areas;
    },
    floorList() {
      return this.floors;
    },
    roomTypeList() {
      return this.roomTypes;
    },
    selectedFloorList() {
      return this.selectedArea.floors.sort((a, b) => {
        if (a.orderNo < b.orderNo) return -1;
        if (a.orderNo > b.orderNo) return 0;
      });
    },
    selectedViewFloorList() {
      return this.viewSelectedArea.floors.sort((a, b) => {
        if (a.orderNo < b.orderNo) return -1;
        if (a.orderNo > b.orderNo) return 0;
      });
    },
    checkedEmployeeCount() {
      var employees = this.allEmployeeFilteredList.filter(a => {
        return a.isCheck == true;
      });
      if (employees[0]) {
        return employees.length;
      } else {
        return 0;
      }
    },
    allEmployeeFilteredList() {
      return this.employees.filter(item => {
        return item.roomId == null || item.roomId == this.viewSelectedRoom.id;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 240;
        return "height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowEmployeesHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 280;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    customColor2() {
      if (this.viewSelectedRoom.capacity <= this.viewSelectedRoom.usesCount) {
        return "detail-box bg-red text-center";
      } else if (
        this.viewSelectedRoom.usesCount > 0 &&
        this.viewSelectedRoom.usesCount < this.viewSelectedRoom.capacity
      ) {
        return "detail-box bg-blue text-center";
      } else if (this.viewSelectedRoom.usesCount == 0) {
        return "detail-box bg-green text-center";
      } else {
        return "detail-box bg-warning text-center";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    openDevice() {
      const width = 800;
      const height = 600;

      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      window.open(
        "https://kamera-linkin.com",
        "cameraWindow",
        `width=${width},height=${height},top=${top},left=${left}`
      );
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    async roomDetail(room) {
      this.employees = [];
      this.viewSelectedRoom.id = room.id;
      this.viewSelectedRoom.name = room.name;
      this.viewSelectedRoom.capacity = room.capacity;
      this.viewSelectedRoom.orderNo = room.orderNo;
      this.viewSelectedRoom.usesEmployees = room.usesEmployees;
      this.viewSelectedRoom.floorId = room.floorId;
      this.viewSelectedRoom.areaId = room.areaId;
      this.viewSelectedRoom.roomTypeId = room.roomTypeId;
      this.viewSelectedRoom.usesCount = room.usesCount;
      $("#modal-room-detail").modal("show");
      await this.getUsesByRoomId(room.id);
    },
    editRoom() {
      if (this.viewSelectedRoom.id) {
        this.selectRoom(this.viewSelectedRoom.id);
        $("#room-modal").modal("show");
      }
    },
    newRoomType() {
      this.isNewRoomType = true;
      this.selectedRoomType.id = null;
      this.selectedRoomType.name = "";
    },
    selectRoomType(id, name) {
      this.isNewRoomType = false;
      this.selectedRoomType.id = id;
      this.selectedRoomType.name = name;
    },
    getRoomTypeName(id) {
      var roomType = this.roomTypeList.filter(a => {
        return a.id == id;
      });
      if (roomType[0]) {
        return roomType[0].name;
      } else {
        return "-";
      }
    },
    async deleteRoomType(id) {
      if (!id) {
        alertify.warning(this.$ml.get("alerts.selectedMealNotBlank"));
      } else {
        try {
          this.isLoadingDetail = true;
          const response = await this.$axios
            .delete("/RoomType/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          await this.newRoomType();
          await this.getRoomTypes();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingDetail = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingDetail = false;
        }
      }
    },
    async saveRoomType() {
      if (this.isNewRoomType) {
        if (this.selectedRoomType.name == "") {
          alertify.warning(this.$ml.get("alerts.foodGroupNameNotBlank"));
          return;
        }
        this.isLoadingDetail = true;
        try {
          const response = await this.$axios
            .post("/RoomType", {
              name: this.selectedRoomType.name
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            await this.newRoomType();
            await this.getRoomTypes();
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          const response = await this.$axios
            .post("/RoomType/" + this.selectedRoomType.id, {
              name: this.selectedRoomType.name
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            await this.newRoomType();
            await this.getRoomTypes();
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async viewSelectArea($event) {
      var id = event.target.value;
      if (id) {
        await this.getFloorsByAreaId(id);
        await this.viewRefreshArea(id);
      } else {
        this.viewSelectedArea.id = null;
        this.viewSelectedArea.name = "";
        this.viewSelectedArea.floors = [];
      }
    },
    viewRefreshArea(id) {
      this.viewSelectedArea.id = id;
      var area = this.areaList.filter(a => {
        return a.id == id;
      });
      if (area[0]) {
        this.viewSelectedArea.name = area[0].name;
        this.viewSelectedArea.floors = [];
        this.viewSelectedArea.floors = this.floorList.filter(a => {
          return a.areaId == id;
        });
      } else {
        this.viewSelectedArea.id = null;
        this.viewSelectedArea.name = "";
        this.viewSelectedArea.floors = [];
      }
    },
    async newEmployees() {
      if (this.viewSelectedRoom.capacity == this.viewSelectedRoom.usesCount) {
        alertify.warning("Odada yeterli boş alan mevcut değil...");
        return;
      }
      //await this.getAllEmployees();
      await this.allEmployeeFilteredList.forEach(a => {
        if (a.isCheck == true) {
          a.isCheck = false;
          a.isAtRoom = false;
        }
        var result = this.viewSelectedRoom.usesEmployees.filter(b => {
          return b.id == a.id;
        });
        if (result[0]) {
          a.isCheck = true;
          a.isAtRoom = true;
        }
      });
      await $("#employees-modal").modal("show");
    },
    async addEmployee() {
      var employees = this.allEmployeeFilteredList.filter(a => {
        return a.isCheck == true && a.isAtRoom == false;
      });
      var ids = [];
      if (employees[0]) {
        employees.forEach(b => {
          ids.push(b.id);
        });
        try {
          const response = await this.$axios
            .post("/AreaDefinition/SetEmployeesToRoom", {
              ids: ids,
              roomId: this.viewSelectedRoom.id
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            await $("#employees-modal").modal("hide");
            await this.getUsesByRoomId(this.viewSelectedRoom.id);
            this.viewSelectedRoom.usesCount = this.viewSelectedRoom.usesEmployees.length;
            var floor = this.floorList.filter(a => {
              return a.id == this.viewSelectedRoom.floorId;
            });
            if (floor[0]) {
              var room = floor[0].rooms.filter(b => {
                return b.id == this.viewSelectedRoom.id;
              });
              if (room[0]) {
                room[0].usesCount = this.viewSelectedRoom.usesEmployees.length;
              } else {
                await $("#modal-room-detail").modal("hide");
                await this.getFloorsByAreaId(this.viewSelectedArea.id);
                await this.viewRefreshArea(this.viewSelectedArea.id);
                await this.scrollToAnchor(this.viewSelectedRoom.id);
              }
            } else {
              await $("#modal-room-detail").modal("hide");
              await this.getFloorsByAreaId(this.viewSelectedArea.id);
              await this.viewRefreshArea(this.viewSelectedArea.id);
              await this.scrollToAnchor(this.viewSelectedRoom.id);
            }
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      }
    },
    async removeEmployee(emp, index) {
      try {
        const response = await this.$axios
          .post("/AreaDefinition/RemoveEmployeesToRoom?employeeId=" + emp.id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        let id = response.data.id;
        if (response.status == 200) {
          this.viewSelectedRoom.usesEmployees.splice(index, 1);
          this.viewSelectedRoom.usesCount = this.viewSelectedRoom.usesEmployees.length;
          var floor = this.floorList.filter(a => {
            return a.id == this.viewSelectedRoom.floorId;
          });
          if (floor[0]) {
            var room = floor[0].rooms.filter(b => {
              return b.id == this.viewSelectedRoom.id;
            });
            if (room[0]) {
              room[0].usesCount = this.viewSelectedRoom.usesEmployees.length;
            } else {
              await $("#modal-room-detail").modal("hide");
              await this.getFloorsByAreaId(this.viewSelectedArea.id);
              await this.viewRefreshArea(this.viewSelectedArea.id);
              await this.scrollToAnchor(this.viewSelectedRoom.id);
            }
          } else {
            await $("#modal-room-detail").modal("hide");
            await this.getFloorsByAreaId(this.viewSelectedArea.id);
            await this.viewRefreshArea(this.viewSelectedArea.id);
            await this.scrollToAnchor(this.viewSelectedRoom.id);
          }
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    customColor(room) {
      if (room) {
        if (room.capacity <= room.usesCount) {
          return "info-box-icon bg-red box-w-70";
        } else if (room.usesCount > 0 && room.usesCount < room.capacity) {
          return "info-box-icon bg-blue box-w-70";
        } else if (room.usesCount == 0) {
          return "info-box-icon bg-green box-w-70";
        } else {
          return "info-box-icon bg-warning box-w-70";
        }
      } else {
        return "info-box-icon box-w-70";
      }
    },
    changeRoomType(event) {
      this.viewSelectedRoom.roomTypeId = event.target.value;
    },
    clearRoom() {
      this.isNewRoom = true;
      this.viewSelectedRoom.id = null;
      this.viewSelectedRoom.name = "";
      this.viewSelectedRoom.capacity = 1;
      this.viewSelectedRoom.orderNo = 1;
      this.viewSelectedRoom.usesEmployees = [];
      this.viewSelectedRoom.floorId = null;
      this.viewSelectedRoom.areaId = null;
      this.viewSelectedRoom.roomTypeId = null;
      this.viewSelectedRoom.usesCount = 0;
    },
    newRoom(floorId, areaId) {
      this.clearRoom();
      this.viewSelectedRoom.floorId = floorId;
      this.viewSelectedRoom.areaId = areaId;
      $("#room-modal").modal("show");
    },
    selectRoom(id) {
      this.isNewRoom = false;
      this.viewSelectedRoom.id = id;
      var room = this.rooms.filter(a => {
        return a.id == id;
      });
      if (room[0]) {
        this.viewSelectedRoom.name = room[0].name;
        this.viewSelectedRoom.capacity = room[0].capacity;
        this.viewSelectedRoom.orderNo = room[0].orderNo;
        this.viewSelectedRoom.usesEmployees = room[0].usesEmployees;
        this.viewSelectedRoom.floorId = room[0].floorId;
        this.viewSelectedRoom.areaId = room[0].areaId;
        this.viewSelectedRoom.roomTypeId = room[0].roomTypeId;
        this.viewSelectedRoom.usesCount = room[0].usesCount;
      }
    },
    async saveRoom() {
      if (this.isNewRoom) {
        if (this.viewSelectedRoom.name == "") {
          alertify.warning(this.$ml.get("alerts.foodGroupNameNotBlank"));
          return;
        }
        this.isLoadingDetail = true;
        try {
          const response = await this.$axios
            .post("/AreaDefinition", {
              name: this.viewSelectedRoom.name,
              type: 2,
              floorId: this.viewSelectedRoom.floorId,
              areaId: this.viewSelectedRoom.areaId,
              capacity: this.viewSelectedRoom.capacity,
              orderNo: this.viewSelectedRoom.orderNo,
              roomTypeId: this.viewSelectedRoom.roomTypeId
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            $("#room-modal").modal("hide");
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          await this.getFloorsByAreaId(this.viewSelectedArea.id);
          await this.viewRefreshArea(this.viewSelectedArea.id);
          await this.selectRoom(id);
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          const response = await this.$axios
            .post("/AreaDefinition/" + this.viewSelectedRoom.id, {
              name: this.viewSelectedRoom.name,
              type: 2,
              floorId: this.viewSelectedRoom.floorId,
              areaId: this.viewSelectedRoom.areaId,
              capacity: this.viewSelectedRoom.capacity,
              orderNo: this.viewSelectedRoom.orderNo,
              roomTypeId: this.viewSelectedRoom.roomTypeId
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            $("#room-modal").modal("hide");
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          await this.getFloorsByAreaId(this.viewSelectedArea.id);
          await this.viewRefreshArea(this.viewSelectedArea.id);
          await this.selectRoom(this.viewSelectedRoom.id);
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    newArea() {
      this.isNewArea = true;
      this.selectedArea.id = null;
      this.selectedArea.name = "";
      this.selectedArea.floors = [];
      this.newFloor();
    },
    selectArea(id) {
      this.isNewArea = false;
      this.selectedArea.id = id;
      var area = this.areaList.filter(a => {
        return a.id == id;
      });
      if (area[0]) {
        this.selectedArea.name = area[0].name;
      }
      this.selectedArea.floors = [];
      this.selectedArea.floors = this.floorList.filter(a => {
        return a.areaId == id;
      });
      this.newFloor();
    },
    async saveArea() {
      if (this.isNewArea) {
        if (this.selectedArea.name == "") {
          alertify.warning(this.$ml.get("alerts.foodGroupNameNotBlank"));
          return;
        }
        this.isLoadingDetail = true;
        try {
          const response = await this.$axios
            .post("/AreaDefinition", {
              name: this.selectedArea.name,
              type: 0,
              floorId: null,
              areaId: null,
              capacity: 0,
              orderNo: 0,
              roomTypeId: null
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            this.selectArea(id);
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getAreas();
          this.isNewArea = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          const response = await this.$axios
            .post("/AreaDefinition/" + this.selectedArea.id, {
              name: this.selectedArea.name,
              type: 0,
              floorId: null,
              areaId: null,
              capacity: 0,
              orderNo: 0,
              roomTypeId: null
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            this.selectArea(this.selectedArea.id);
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getAreas();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    newFloor() {
      this.isNewFloor = true;
      this.selectedFloor.id = null;
      this.selectedFloor.name = "";
      this.selectedFloor.orderNo = 1;
      this.selectedFloor.areaId = this.selectedArea.id;
    },
    selectFloor(id) {
      this.isNewFloor = false;
      this.selectedFloor.id = id;
      var floor = this.floorList.filter(a => {
        return a.id == id;
      });
      if (floor[0]) {
        this.selectedFloor.name = floor[0].name;
        this.selectedFloor.orderNo = floor[0].orderNo;
        this.selectedFloor.areaId = floor[0].areaId;
      }
    },
    async saveFloor() {
      if (this.isNewFloor) {
        if (this.selectedFloor.name == "") {
          alertify.warning(this.$ml.get("alerts.foodGroupNameNotBlank"));
          return;
        }
        this.isLoadingDetail = true;
        try {
          const response = await this.$axios
            .post("/AreaDefinition", {
              name: this.selectedFloor.name,
              type: 1,
              floorId: null,
              areaId: this.selectedArea.id,
              capacity: 0,
              orderNo: this.selectedFloor.orderNo,
              roomTypeId: null
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (response.status == 200) {
            await this.getFloorsByAreaId(this.selectedArea.id);
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.isNewFloor = true;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          const response = await this.$axios
            .post("/AreaDefinition/" + this.selectedFloor.id, {
              name: this.selectedFloor.name,
              type: 1,
              floorId: null,
              areaId: this.selectedArea.id,
              capacity: 0,
              orderNo: this.selectedFloor.orderNo,
              roomTypeId: null
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            await this.getFloorsByAreaId(this.selectedArea.id);
            alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async deleteField(id, type) {
      if (!id) {
        alertify.warning(this.$ml.get("alerts.selectedMealNotBlank"));
      } else {
        try {
          this.isLoadingDetail = true;
          const response = await this.$axios
            .delete("/AreaDefinition/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (type == 0) {
            await this.newArea();
            await this.getAreas();
          } else if (type == 1) {
            await this.newFloor();
            await this.getFloorsByAreaId(this.selectedArea.id);
          } else {
            $("#room-modal").modal("hide");
            $("#modal-room-detail").modal("hide");
            await this.clearRoom();
            await this.getFloorsByAreaId(this.viewSelectedArea.id);
            await this.viewRefreshArea(this.viewSelectedArea.id);
          }
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingDetail = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getAreas() {
      try {
        this.isLoading = true;
        const areas = [];
        const response = await this.$axios
          .get("/AreaDefinition/Area")
          .then(response => {
            response.data.forEach(doc => {
              //Bölge
              areas.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.areas = areas;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getFloorsByAreaId(areaId) {
      try {
        this.isLoading = true;
        const floors = [];
        const response = await this.$axios
          .get("/AreaDefinition/FloorsByAreaId?areaId=" + areaId)
          .then(response => {
            response.data.forEach(doc => {
              //Katlar
              var rooms1 = doc.rooms.sort((a, b) => {
                if (a.orderNo < b.orderNo) return -1;
                if (a.orderNo > b.orderNo) return 0;
              });
              floors.push({
                id: doc.id,
                name: doc.name,
                areaId: doc.areaId,
                orderNo: doc.orderNo,
                rooms: rooms1
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.floors = floors;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getUsesByRoomId(roomId) {
      try {
        this.isLoadingUsesEmployees = true;
        const usesEmployees = [];
        const response = await this.$axios
          .get("/AreaDefinition/UsesByRoomId?roomId=" + roomId)
          .then(response => {
            response.data.forEach(doc => {
              usesEmployees.push(doc);
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingUsesEmployees = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingUsesEmployees = false;
                return;
              }
            }
          });
        this.viewSelectedRoom.usesEmployees = usesEmployees;
        this.isLoadingUsesEmployees = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingUsesEmployees = false;
      }
    },
    async getFloorsByAreaId(areaId) {
      try {
        this.isLoading = true;
        const floors = [];
        const response = await this.$axios
          .get("/AreaDefinition/FloorsByAreaId?areaId=" + areaId)
          .then(response => {
            response.data.forEach(doc => {
              //Katlar
              var rooms1 = doc.rooms.sort((a, b) => {
                if (a.orderNo < b.orderNo) return -1;
                if (a.orderNo > b.orderNo) return 0;
              });
              floors.push({
                id: doc.id,
                name: doc.name,
                areaId: doc.areaId,
                orderNo: doc.orderNo,
                rooms: rooms1
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.floors = floors;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getRoomTypes() {
      try {
        this.isLoading = true;
        const roomTypes = [];
        const response = await this.$axios
          .get("/RoomType")
          .then(response => {
            response.data.forEach(doc => {
              roomTypes.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.roomTypes = roomTypes;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAllEmployees() {
      try {
        this.isLoadingEmployee = true;
        const allEmployees = [];
        const response = await this.$axios
          .get("/Employees")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (doc.isVisitor == false) {
                  allEmployees.push({
                    id: doc.id,
                    name: doc.name,
                    title: doc.title,
                    registrationNo: doc.registrationNo,
                    roomId: doc.roomId,
                    isVisitor: doc.isVisitor,
                    isCheck: false,
                    isAtRoom: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.employees = allEmployees;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
      }
    },
    async getEmployees() {
      if (this.filters.nameOrCardNumber == "") {
        alertify.warning("Lütfen arama kısmını boş bırakmayın...");
        return;
      }
      try {
        this.isLoadingEmployee = true;
        var employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              var a = doc;
              a.isCheck = false;
              a.isAtRoom = false;
              employees.push(a);
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              } else if (error.response.status == 403) {
                alertify.message(
                  this.$ml.get("alerts.userIsNotAuthorizedToSeeData")
                );
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    scrollToAnchor(aid) {
      var aTag = $(".room[name='" + aid + "']");
      $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      //this.getEmployees();
    }
    await this.getRoomTypes();
    await this.getAreas();
  }
};
</script>
<style scoped>
.ml-80 {
  margin-left: 60px;
}

.box-w-70 {
  width: 60px;
}

.detail-box {
  border-top-left-radius: 2px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 2px;
  display: block;
  float: center;
  height: 200px;
  width: 100%;
  text-align: center;
  font-size: 45px;
  line-height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/pages/buildings/BuildDefinitionsTest.vue